import { combineReducers } from 'redux';
import { ACTIONS } from 'a/pictureThis/data/constants';
import draggables, * as fromDraggables from './draggables';
import dropzone, * as fromDropzone from './dropzone';
import stickerCollection, * as fromStickerCollection from './stickerCollection';

const isUserDragging = (state = false, { type }) => {
  switch (type) {
    case ACTIONS.START_GROUP_DRAG:
      return true;
    case ACTIONS.SELECT_LEVEL:
    case ACTIONS.STOP_GROUP_DRAG:
      return false;
    default:
      return state;
  }
};

export const areWordsReturning = (state = false, { type }) => {
  switch (type) {
    case ACTIONS.STOP_GROUP_DRAG:
      return true;
    case ACTIONS.SELECT_LEVEL:
    case ACTIONS.GROUP_GOT_HOME:
      return false;
    default:
      return state;
  }
};

const isShowingPayoff = (state = false, { type }) => {
  switch (type) {
    case ACTIONS.ADVANCE_CONTENT:
    case ACTIONS.SELECT_LEVEL:
      return false;
    case ACTIONS.SHOW_PAYOFF:
      return true;
    default:
      return state;
  }
};

export const totalElementsInItem = (state = -1, { type, payload }) => {
  switch (type) {
    case ACTIONS.SELECT_LEVEL:
      return -1;
    case ACTIONS.CREATE_VIEW_MODEL_FROM_CONTENT:
      return payload.uniqueElements.length;
    default:
      return state;
  }
};

const usedElements = (state = [], { type, payload }) => {
  switch (type) {
    case ACTIONS.ADVANCE_CONTENT:
    case ACTIONS.SELECT_LEVEL:
      return [];
    case ACTIONS.SET_ELEMENT_AS_USED:
      return [...state, payload];
    default:
      return state;
  }
};

const standardView = combineReducers({
  isShowingPayoff,
  draggables,
  totalElementsInItem,
  isUserDragging,
  dropzone,
  stickerCollection,
  areWordsReturning,
  usedElements,
});

export default standardView;

// selectors from here
export const getIsShowingPayoff = state => state.isShowingPayoff;

export const getIsUserDragging = state => state.isUserDragging;

export const getAreWordsReturning = state => state.areWordsReturning;

export const getIsStoryDone = state =>
  (state.totalElementsInItem - getCollectedElements(state).length) === 0;

export const getScrollPanelPosition = state =>
  state.scrollPanelPosition.delta + state.scrollPanelPosition.origin;

// selectors from draggables
export const getDraggablesTextsByPage = (state, page) =>
  fromDraggables.getDraggablesTextsByPage(state.draggables, page);

export const getIsGroupActive = (state, groupId) =>
  fromDraggables.getIsGroupActive(state.draggables, groupId);

export const getIsGroupDragged = (state, groupId) =>
  fromDraggables.getIsGroupDragged(state.draggables, groupId);

export const getGroupIsReturning = (state, groupId) =>
  fromDraggables.getGroupIsReturning(state.draggables, groupId);

export const getGroupOffset = (state, groupId) =>
  fromDraggables.getGroupOffset(state.draggables, groupId);

export const getGroupText = (state, id) =>
  fromDraggables.getGroupText(state.draggables, id);

export const getGroupUuid = (state, id) =>
  fromDraggables.getGroupUuid(state.draggables, id);

// selectors from dropzone
export const getDropzoneLayout = state =>
  fromDropzone.getLayout(state.dropzone);

export const getIsDropzoneTouching = state =>
  fromDropzone.isTouching(state.dropzone);

export const getDropzoneStoryTag = state =>
  fromDropzone.getStoryTag(state.dropzone);

export const getDropzoneShakeTrigger = state =>
  fromDropzone.getShakeTrigger(state.dropzone);

// selectors from stickerCollecton
export const getCollectedElements = state =>
  fromStickerCollection.getCollectedElements(state.stickerCollection);

export const getIsShowingImage = state =>
  fromStickerCollection.getIsShowingImage(state.stickerCollection);
